import React from "react";
import { IWizardConfig, SubmitButtonColor } from "../../wizard/types";
import DeactivateContent from "../../../components/DeactivateContent/DeactivateContent";
import { ENTITY_NAMES } from "../../../constants";
import { IBranchWizardConfigs, IGetDeactivateConfig } from "../types";
import deactivateFormValidator from "../validators/deactivateFormValidator";

export function useBranchConfig(): IBranchWizardConfigs {
  const getDeactivateConfig = ({
    approved,
    pending,
  }: IGetDeactivateConfig): IWizardConfig => ({
    steps: [
      {
        titleConfig: {
          titleText: "Deactivate branch",
        },
        width: "552px",
        content: () => <DeactivateContent name={ENTITY_NAMES.branch} />,
        validator: deactivateFormValidator,
      },
    ],
    submitButtonText: "Deactivate",
    submitButtonColor: SubmitButtonColor.Danger,
    cancelButtonText: "Close",
    showSuccessNotification: false,
    saveCallback: async (data) => ({
      data: {
        reason: data.reason,
      },
    }),
    getInitialData: async () => ({
      injectedData: {
        approved,
        pending,
      },
    }),
  });

  return {
    getDeactivateConfig,
  };
}
